import { ProjectProps } from "@/interfaces/project_types";
import { PrintProjectCard} from "./PrintProjectCard";

export function PrintClientSection({ client, projects, index }: { client: string; projects?: ProjectProps[]; index: number; }) {
    const filteredProjects = projects?.filter(project => project.client?.name === client) || []
    
    // Don't render if no projects for this client
    if (filteredProjects.length === 0) {
        return null
    }
    
    return (
        <div key={index} className="mb-4">
            <h4 className="text-sm px-1 mb-1">Total Projects: {filteredProjects.length}</h4>
            <h3 className="mb-2">{client || "(No Client Name Provided)"}</h3>

            {/* The column headers */}
            <div className="grid grid-cols-4 p-2 text-xs bg-gray-100 border-b-2">
                <h4 className="text-sm">Project ID</h4>
                <h4 className="text-sm">Project Name</h4>
                <h4 className="text-sm">Status</h4>
                <h4 className="text-sm">Checklist</h4>
            </div>

            <div>
                {filteredProjects.map((project, projectIndex) => 
                    <PrintProjectCard project={project} index={projectIndex} key={projectIndex} />
                )}
            </div>
        </div>
    )
}
